import { Injectable } from '@angular/core';
import { CurrentUser } from './current-user';
import { OrganizationsNavigationProvider } from '../../organizations/providers/navigation-provider';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { from, Observable, of, switchMap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Organization } from "../models/organization";
import { map } from "rxjs/operators";
import { OrganizationMembership } from "../models/organization-membership";

@Injectable({
    providedIn: "root"
})
export class UserDefaultHomepageService {
    public organization: Organization | null = null;
    public dashboardUrl = '/organizations';

    constructor(
        private route: ActivatedRoute,
        private organizationNavigation: OrganizationsNavigationProvider,
        public currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
    ) {
    }

  public getDashboardUrl(): Observable<string> {
    return this.currentUser.getOrganizationsMemberships().pipe(
      switchMap((memberships: OrganizationMembership[]) => {
        if (memberships && memberships.length === 1) {
          this.organization = memberships[0].organization!;
          if (!this.organization?.id) {
            return of(this.dashboardUrl);
          }
          const roles = this.currentUserRoles.getRolesIds(this.organization.id);
          return this.currentUser.getMainHomeUrl(this.organization, roles);
        } else {
          return this.organizationNavigation.getOrganisationFromRoute().pipe(
            switchMap((organization: Organization | null) => {
              this.organization = organization;
              if (!this.organization?.id) {
                return of(this.dashboardUrl);
              }
              const roles = this.currentUserRoles.getRolesIds(this.organization.id);
              return this.currentUser.getMainHomeUrl(this.organization, roles);
            })
          );
        }
      })
    );
  }

}
